import styled from 'styled-components'

import { Box, Modal } from 'app/components/design-system-components'
import theme from 'app/match/applicationReportPDF/assets/theme'

const StyledUL = styled.ul`
  margin-left: ${theme.space[4]}px !important;
  padding-left: ${theme.space[4]}px !important;
  li {
    display: list-item;
  }
`

interface PremierPlanContinueModalProps {
  primaryAction: () => void
  secondaryAction: () => void
}

function ActivateGroupBundleContinueModal({
  primaryAction,
  secondaryAction,
}: PremierPlanContinueModalProps) {
  return (
    <Modal
      modalHeading="Premier plan only"
      modalBody={
        <Box style={{ lineHeight: theme.lineHeights.encrption }} mt={3}>
          This is a paid bundle that requires a Premier plan. Obtain Snug
          General Manager approval on Zendesk ticket to activate. It will
          provide access to the following features:
          <StyledUL>
            <li>Group reporting</li>
            <li>Group prospecting</li>
            <li>Pods</li>
            <li>Multiple trust accounts</li>
          </StyledUL>
        </Box>
      }
      primaryLabel="Cancel"
      secondaryLabel="Continue"
      primaryAction={primaryAction}
      secondaryAction={secondaryAction}
      toggleModal={secondaryAction}
      modalFooter={undefined}
    />
  )
}

export default ActivateGroupBundleContinueModal
